import React, { useEffect } from 'react';
import './App.css';
import RootNavigator from './navigation/root';
import {Provider} from 'react-redux';
import {store} from './redux/store';
import './i18n';
import { isLocalMirror } from './config/constants';
function App() {

  // En el kiosko el menú ya viene servido desde el disco del iPad por el
  // servidor local: el Service Worker no aporta nada y su auto-reload al
  // detectar "nueva versión" puede dejar la pantalla en un ciclo de recargas.
  if (!isLocalMirror && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
          // Verificar si hay una nueva versión disponible
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // Nueva versión disponible
                  console.log('Nueva versión disponible. Por favor, recarga la página.');
                  // Aquí puedes mostrar un aviso al usuario o forzar la recarga
                  window.location.reload();
                } else {
                  // Contenido cacheado por primera vez
                  console.log('Contenido cacheado por primera vez.');
                }
              }
            };
          };
        })
        .catch((error) => console.error('Error al registrar el Service Worker:', error));
    });
  }
  
  
  useEffect(() => {
    getStorage();
    const prevent = (e) => e.preventDefault();
    document.addEventListener('contextmenu', prevent);
    document.addEventListener('selectstart', prevent);
    document.addEventListener('dragstart', prevent);
    return () => {
      document.removeEventListener('contextmenu', prevent);
      document.removeEventListener('selectstart', prevent);
      document.removeEventListener('dragstart', prevent);
    };
  }, []);

  const getStorage = async () => {
    if ('storage' in navigator && 'estimate' in navigator.storage) {
      const estimate =  await navigator.storage.estimate();
      console.log(`Uso actual: ${estimate.usage} bytes`);
      console.log(`Cuota total: ${estimate.quota} bytes`);

      if (estimate.usage / estimate.quota > 0.9) {
        console.warn('Almacenamiento casi lleno. Considera liberar espacio.');
      }
    }

    if ('storage' in navigator && 'persist' in navigator.storage) {
      const isPersisted = await navigator.storage.persist();
      console.log(`Almacenamiento persistente habilitado: ${isPersisted}`);
    }

  }

  return (
    <div className="App">
      <Provider store={store}>
        <RootNavigator  />
      </Provider>
    </div>
  );
}

export default App;
